import { render } from "./agent-bar.vue?vue&type=template&id=10bd50f2"
import script from "./agent-bar.js?vue&type=script&lang=js"
export * from "./agent-bar.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__